import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AdminLayoutComponent} from './layout/admin-layout/admin-layout.component';
import {NotAuthorizedComponent} from './modules/auth/not-authorized/not-authorized.component';
import {NotFoundComponent} from './modules/admin/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/admin/admin.module').then(m => m.AdminModule)
      }
    ]
  },
  {
    component: NotAuthorizedComponent,
    path: 'not-authorization',
    loadChildren: () =>
      import('./modules/auth/not-authorized/not-authorized.module').then((m) => m.NotAuthorizedModule),
  },
  {
    component: NotFoundComponent,
    path: '404'
  },
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'}),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
